import React from "react";
import "./Finances.css";
import Resources from "../../../Resources/Resources";
import {Container, Row, Col, Modal} from "react-bootstrap";
import {
  APP_SECTION, FINANCES,
  STORAGE_KEYS
} from "../../../scripts/constants";
import {saveApplication} from "../../../scripts/sync-manager";
import {mygaSession} from "../../../scripts/myga-session";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {isPaymentScenarioValid, isReplacementOrCD, reconcilePaymentsForProducts} from "../../../scripts/validation";
import {NassauLog} from "../../../scripts/myga-utils";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";

class Finances extends React.Component {
  
  constructor(props) {
    super(props);
    // setup default prev/next pages with props overrides
    // this.prevPage = props.prevPage || PAGES.pageAppPremium; // 2021.07.14.ADivelbiss - commented in favor of PageManager page stack solution
    // this.nextPage = props.nextPage || PAGES.pageAppGoals; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
    
    // Load the component state from the current application
    this.state = {
      errorMessage: '',
      finances: {...mygaSession.getCurrentAppFinances()},
      appStateAbbr: mygaSession.getMygaSessionValue(STORAGE_KEYS.AppStateAbbr),
      showKnockOutMessage: false
    };
    
  }
  
  componentDidMount() {
  
  }
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finances_ErrorMissingInformation
      });
      return false;
    }

    // 2021.09.07.ADivelbiss - Let the validation system drive to the knockout page
    // // Check for finance "knockouts" using the global condition definitions
    // const knockoutCondition = {
    //   name: "knockoutFinances",
    //   value: true
    // };
    // if (validateCondition(knockoutCondition, this.state)) {
    //   this.setState({
    //     showKnockOutMessage: true
    //   });
    //   return false;
    // }
    
    return true;
  };

  onBackPressed = async () => {
    await this.saveApplication()
  }

  onNextPressed = async () => {
    await this.saveApplication()
  }
  
  saveApplication = async () => {
    // populate finance object from fields
    const finances = this.state.finances;
    if (finances[FINANCES.expensesMonthly]>0) {
      finances[FINANCES.expensesAnnual] = `${finances[FINANCES.expensesMonthly] * 12}`;
    }
    NassauLog(`Finances: finances: ${JSON.stringify(finances,null,2)}`);
    
    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.finances,finances);
    
    await saveApplication(APP_SECTION.finances)
  
    // 2021.09.08.ADivelbiss - Check to see if payments should be cleared.
    // Do this after the finances data are saved
    const nextProductDTOs = reconcilePaymentsForProducts();
    if (nextProductDTOs) {
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs);
      await saveApplication(APP_SECTION.products)
    }
  };
  
  handleChange = (field) => (e) => {
    // NassauLog(`finances.handleChange: ${field} = ${e.target ? e.target.value : e}`);
    let finances = this.state.finances;
    finances[field] = e.target ? e.target.value : e;
    
    this.setState({
      finances: finances,
      errorMessage:'',
    });
  };
  
  render() {
    
    return (
        
        <AppContentWrapper
            onBackPressed={this.onBackPressed}
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>
          
          <form className={'needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>
            <Container className={'pt-5 pl-4 pr-4'}>
  
              {/*  Explanation */}
              {/* 2022.06.27.ADivelbiss - added to match compliance feedback on FL flow page*/}
              <Container>
                <Row className="page-question pt-0 mt-0">
                  <Col className=" text-center pb-0">
                    <div>What is your approximate income...&nbsp;
                      {/*<PopoverTooltip content={Resources.Strings.Finances_InfoIncomeAndExpenses}/>*/}
                    </div>
                  </Col>
                </Row>
                <Row className="page-question pt-0 mt-0 text-left">
                  <Col sm={8} className="offset-sm-2 text-left pt-0 pb-4" >
                    <div className={'font-page-small'}><b>Why are we asking? </b>{Resources.Strings.Finances_InfoIncomeAndExpenses}
                    </div>
                  </Col>
                </Row>
              </Container>
              
              <Question
                containerClass={'offset-xs-0 offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('annualIncome')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('monthlyExpenses')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-3'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('netWorth')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-4'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('liquidAssets')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'offset-sm-2 pb-4'}
                questionClass={'font-page-regular'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('ageRange')}
                onChange={this.handleChange}/>

              <Question
                containerClass={'pb-1'}
                data={this.state.finances}
                question={PageManager.getQuestionByName('hasOtherContracts')}
                onChange={this.handleChange}/>
  
              {/* 2022.06.27.ADivelbiss - commented to match compliance feedback on FL flow page*/}
              {/*<Row className="page-question pt-0 mt-0 text-left">*/}
              {/*  <Col sm={8} className=" offset-sm-2 text-left pt-4 pb-4" >*/}
              {/*    <div className={'font-page-small'}><b>Why are we asking? </b>{Resources.Strings.Finances_InfoIncomeAndExpenses}*/}
              {/*    </div>*/}
              {/*  </Col>*/}
              {/*</Row>*/}

            </Container>
          </form>
          
          <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showKnockOutMessage}
              onHide={()=>{
                this.setState({
                  showKnockOutMessage: false
                })
              }}
          >
            
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  {MYGAStrings.Finances_ErrorCallForHelp}
                </Col>
              </Row>
            
            </Modal.Body>
          
          </Modal>
        
        </AppContentWrapper>
    
    );
    
  }
}

export default Finances;